import { render, staticRenderFns } from "./UpdateMemberModal.vue?vue&type=template&id=7a4f3262"
import script from "./UpdateMemberModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpdateMemberModal.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports